import Vue from 'vue'
import Vuex from 'vuex'
import { EmissorDeCartao } from '@/resources/EmissorDeCartao.resource.js'
import { CARTAO } from '@/enums/cartao.js'

Vue.use(Vuex)

export default {
  state: {
    cardIssuer: {}
  },
  mutations: {
    setCardIssuer(state, { items, idPaymentMethod }) {
      state.cardIssuer[idPaymentMethod] = items;
    },
    setCardIssuerDebit(state, cardIssuer) {
      state.cardIssuer[CARTAO.DEBITO] = cardIssuer;
    },
    setCardIssuerCredit(state, cardIssuer) {
      state.cardIssuer[CARTAO.CREDITO] = cardIssuer;
    },
  },
  actions: {
    cardIssuer: ({ commit, state }, payload) => {
      return new Promise((resolve, reject) => {
        if (typeof state.cardIssuer[payload.paymentMethod] === 'undefined' || state.cardIssuer[payload.paymentMethod].length <= 0) {
          EmissorDeCartao.getLista(payload).then((response) => {
            if (response.data.isSuccess) {
              commit('setCardIssuer', { items: response.data.payload.items, idPaymentMethod: payload.paymentMethod });
              resolve(response.data.payload.items);
            } else {
              reject();
            }
          })
            .catch((e) => {
              reject();
            })
        } else {
          resolve(state.cardIssuer[payload.idPaymentMethod]);
        }
      });
    }
  },
  getters: {
    getCardIssuer: (state) => {
      return state.cardIssuer
    },
    getCardIssuerDebit: (state) => {
      return state.cardIssuer[CARTAO.DEBITO]
    },
    getCardIssuerCredit: (state) => {
      return state.cardIssuer[CARTAO.CREDITO]
    }
  },
}
